import { render, staticRenderFns } from "./SmsPartnerTariffZones.vue?vue&type=template&id=081441c0&"
import script from "./SmsPartnerTariffZones.vue?vue&type=script&lang=ts&"
export * from "./SmsPartnerTariffZones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports